import { useState } from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  Button,
  Input,
  Spinner
} from '@heroui/react';

const OrgInviteModal = ({org, dismissModal}) => {
  const [email, setEmail] = useState();
  const [banner, setBanner] = useState();
  const [error, setError] = useState();
  const [fetching, setFetching] = useState(false);

  const submitInvite = async () => {
    setBanner();
    setError();
    setFetching(true);
    let fd = new FormData();
    fd.append('email', email.toLowerCase().trim());
    const invite = await fetch(`/api/v1/organizations/${org._id}/invite`, {method: 'PUT', body: fd});
    if (invite.status === 200 || invite.status === 422) {
      const d = await invite.json();
      if (d['success']) {
        setError('');
        setBanner('User invited');
      } else {
        if (d['error'] && invite.status === 422) {
          setError(d['error']);
        } else {
          setError(`Unknown error inviting ${email}: ${invite.status}`);
        }
      }
      setFetching(false);
    } else if (invite.status === 404 || invite.status === 302) {
      window.location.href = invite.url;
    }
  };

  return (
    <Modal isOpen={true} isDismissable={true} onClose={dismissModal}>
      <ModalContent>
        <ModalHeader className='flex flex-col gap-1'>
          Invite a friend to {org.name}
        </ModalHeader>
        <ModalBody>
          { error && <span style={{fontSize: '14px', color: '#ff0000'}}>{error}</span> }
          { banner && <span style={{fontSize: '14px', color: '#108020'}}>{banner}</span> }
          { fetching && <Spinner /> }
          <Input label='Email address' onChange={(d) => setEmail(d.target.value)} />
          <Button onPress={() => submitInvite()}
                  style={{marginTop: '10px', marginBottom: '10px'}}>
            Submit
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default OrgInviteModal;
